/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'admin-hub-focused-task.close.confirm.text': "When you close this window, we don't save your progress. Are you sure you want to continue?",
  'admin-hub-focused-task.close.drawer.button': 'Close',
  'admin-hub-focused-task.default.back.button.text': 'Back',
  'admin-hub-focused-task.default.next.button.text': 'Next',
  'admin-hub-focused-task.error.header': "We're not sure what went wrong",
  'admin-hub-focused-task.progress.tracker': 'Progress tracker'
};